module.exports = __webpack_public_path__ + "img/badge-legal-chemical.16f4e406.svg";